import styled, { css } from 'styled-components';

const withCommandsAreas = css`
    grid-template-columns: calc(1/15 * 100vh) calc(10/15 * 100vh) calc(1/15 * 100vh);
    grid-template-rows:
        calc(1/15 * 100vh)
        calc(10/15 * 100vh)
        calc(1/15 * 100vh)
        calc(2/15 * 100vh)
        calc(1/15 * 100vh);
    grid-template-areas:
        '  .   top   .  '
        'left board  .  '
        ' .   clear  .  '
        ' .  commands . '
        ' .  clearCommands .';

    @media (max-aspect-ratio: 15/9) {
        grid-template-columns: calc(1/15 * 60vw) calc(10/15 * 60vw) calc(1/15 * 60vw);
        grid-template-rows:
            calc(1/15 * 60vw) calc(10/15 * 60vw) calc(1/15 * 60vw) calc(2/15 * 60vw) calc(1/15 * 60vw);
    }

    @media (max-width: 800px) {
        grid-template-columns: calc(1/15 * 800px) calc(10/15 * 800px) calc(1/15 * 800px);
        grid-template-rows:
            calc(1/15 * 800px) calc(10/15 * 800px) calc(1/15 * 800px) calc(2/15 * 800px) calc(1/15 * 800px);
    }

    @media (max-height: 550px) {
        grid-template-columns: calc(1/15 * 550px) calc(10/15 * 550px) calc(1/15 * 550px);
        grid-template-rows:
            calc(1/15 * 550px) calc(10/15 * 550px) calc(1/15 * 550px) calc(2/15 * 550px) calc(1/15 * 550px);
    }
`;

const withEdgeLabelsOnly = css`
    grid-template-columns: calc(1/15 * 100vh) calc(10/15 * 100vh) calc(1/15 * 100vh);
    grid-template-rows:
        calc(1/15 * 100vh)
        calc(10/15 * 100vh)
        calc(1/15 * 100vh);
    grid-template-areas:
        '  .   top   .  '
        'left board  .  '
        ' .   clear  .  ';

    @media (max-aspect-ratio: 15/9) {
        grid-template-columns: calc(1/15 * 60vw) calc(10/15 * 60vw) calc(1/15 * 60vw);
        grid-template-rows:
            calc(1/15 * 60vw) calc(10/15 * 60vw) calc(1/15 * 60vw);
    }

    @media (max-width: 800px) {
        grid-template-columns: calc(1/15 * 800px) calc(10/15 * 800px) calc(1/15 * 800px);
        grid-template-rows:
            calc(1/15 * 800px) calc(10/15 * 800px) calc(1/15 * 800px);
    }

    @media (max-height: 550px) {
        grid-template-columns: calc(1/15 * 550px) calc(10/15 * 550px) calc(1/15 * 550px);
        grid-template-rows:
            calc(1/15 * 550px) calc(10/15 * 550px) calc(1/15 * 550px);
    }
`;

const withoutEdgeLabels = css`
    padding: calc(1/15 * 100vh);
    grid-template-columns: calc(10/15 * 100vh);
    grid-template-rows:
        calc(10/15 * 100vh)
        calc(1/15 * 100vh);
    grid-template-areas:
        'board'
        'clear';

    @media (max-aspect-ratio: 15/9) {
        padding: calc(1/15 * 60vw);
        grid-template-columns: calc(10/15 * 60vw);
        grid-template-rows:
            calc(10/15 * 60vw) calc(1/15 * 60vw);
    }

    @media (max-width: 800px) {
        padding: calc(1/15 * 800px);
        grid-template-columns: calc(10/15 * 800px);
        grid-template-rows:
            calc(10/15 * 800px) calc(1/15 * 800px);
    }

    @media (max-height: 550px) {
        padding: calc(1/15 * 550px);
        grid-template-columns: calc(10/15 * 550px);
        grid-template-rows:
            calc(10/15 * 550px) calc(1/15 * 550px);
    }
`;

const getLayoutStyle = ({ $hasCommands, $hasEdgeLabels }) => {
    if ($hasCommands) return withCommandsAreas;
    if ($hasEdgeLabels) return withEdgeLabelsOnly;
    return withoutEdgeLabels;
};

export const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: grid;
    justify-content: center;

    ${getLayoutStyle}
`;

export const StyledGrid = styled.div`
    background-color: white;
    display: grid;
    grid-template-columns: repeat(${({ $cols }) => $cols}, ${({ $cols }) => 100 / $cols}%);
    grid-template-rows: repeat(${({ $rows }) => $rows}, ${({ $rows }) => 100 / $rows}%);
    grid-area: board;
    border: 1px solid ${({ theme }) => theme.colors.gray};
    border-width: 0 1px 1px 0;
    position: relative;

    ${({ $hasAxisLines }) => $hasAxisLines && css`
        &:before {
            content: "";
            position: absolute;
            top: calc(50% - 2px);
            left: 0;
            width: 100%;
            border-top: 4px solid #2773BE;
            z-index: 2;
            pointer-events: none;
        }

        &:after {
            content: "";
            position: absolute;
            left: calc(50% - 2px);
            top: 0;
            height: 100%;
            border-left: 4px solid #2773BE;
            z-index: 2;
            pointer-events: none;
        }
    `}
`;

export const StyledCommands = styled.div`
    display: grid;
    grid-template-columns: repeat(10, 10%);
    grid-template-rows: repeat(2, 50%);
    border: 1px solid ${({ theme }) => theme.colors.gray};
    border-width: 0 1px 1px 0;
    grid-area: commands;
`;
